/* @flow */

import {
  sideBarLapWidth,
  sideBarTabletWidth,
  mainTabletWidth,
  mainLapWidth,
} from 'src/shared/app/base/component/template/style/template.style';
import { notificationElevation } from 'src/shared/app/base/style/token/elevation';
import { tablet, lap } from '@e180/ui/lib/token/mediaQuery';

export default {
  root: {
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: notificationElevation,

    width: '100%',

    [tablet]: {
      left: sideBarTabletWidth,

      maxWidth: mainTabletWidth,
    },

    [lap]: {
      left: sideBarLapWidth,

      maxWidth: mainLapWidth,
    },
  },
};
